import { useUserSettings } from "@next-platform/client-common-core";
import { CharacterType } from "@next-platform/packages-ts-types";

import { Spinner, Text } from "@/components/customComponents";
import SearchClientCharacterListing from "@/components/search/SearchClientCharacterListing";
import Trans from "@/components/Trans/Trans";
import { default as useFavoritesTabs, FavoritesTab } from "@/pages/Favorites/useFavoritesTabs";

const ChatbotFavorite = () => {
  const { likedBots } = useUserSettings();
  const { tabItems, onTabChange, hasGroupChat, isGroupChatFlagLoading } = useFavoritesTabs();

  const characterType = hasGroupChat ? CharacterType.STANDARD : undefined;

  return (
    <>
      <Text h1 className="m-0 px-4 max-mob:px-2" variant="xxl">
        <Trans i18nKey="chatbot:page.favorites.title.chatbots" />
      </Text>
      {isGroupChatFlagLoading ? (
        <Spinner centerToScreen={true} />
      ) : (
        <SearchClientCharacterListing
          useStoreTagFilters={false}
          charactersList={likedBots}
          characterType={characterType}
          tabItems={tabItems}
          activeTab={FavoritesTab.CHATBOTS}
          onTabChange={onTabChange}
        />
      )}
    </>
  );
};

export default ChatbotFavorite;
